import React, { FunctionComponent, useEffect, useState } from 'react';
import { FormattedMessage, IntlProvider, MessageFormatElement } from 'react-intl';
import { useFormContext, useStepper } from '../../../../hooks';
import { AppAlertDialog } from '../../../shared/general';
import { Box } from '@chakra-ui/react';
import { CalculatorsHomeValueResult } from '../../../../@types/features/calculators';
import useMediaQuery from '../../../../hooks/use-media';
import { mainMediaMobile, scrollTo } from '../../../../utils';
import { CalculatorsHomeValueCta } from './calculator-home-value-cta';
import { CalculatorHomeValueCtaResult } from './calculator-home-value-cta-result';
import { CalculatorHomeValueResult } from './calculator-home-value-result';
import { CalculatorHomeValueStepper } from './stepper';
import { HomeValueProvider } from './context/home-value-context';
import { API_ASSETS } from '../../../../services';
import { sharedUtilsGetLang } from '../../../../utils/lang-utils';

export const CalculatorsHomeValue: FunctionComponent = () => {
  const [locale] = useState(sharedUtilsGetLang());
  const isMobile = useMediaQuery(mainMediaMobile);
  const { setStepActive } = useStepper();
  const { result, hasError, setError, updateResult } = useFormContext<CalculatorsHomeValueResult>();
  const [messages, setMessages] = useState<Record<string, MessageFormatElement[]>>(
    {} as Record<string, MessageFormatElement[]>
  );

  const handleOnClose = () => {
    updateResult(null);
    setError(false);
    setStepActive(0, true);
  };

  useEffect(() => {
    const loadData = async () => {
      const data: Record<string, MessageFormatElement[]> = await API_ASSETS.get(
        `calculators/home-value/compiled-lang/${locale}.json`
      );

      setMessages(data);
    };

    loadData();
  }, [locale]);

  useEffect(() => {
    const ctaButton = document.querySelector<HTMLDivElement>('.c-cta-sticky');
    if (ctaButton) {
      const anchorElement = ctaButton.querySelector<HTMLAnchorElement>('a');
      if (anchorElement) {
        anchorElement.removeAttribute('href');
        anchorElement.addEventListener('click', () => {
          scrollTo('.react-tools');
        });
      }
    }
  }, []);

  return (
    <IntlProvider locale={locale} messages={messages} defaultLocale={'nl'}>
      <HomeValueProvider>
        <div className={`grid grid-cols-12 p-4 md:p-0`}>
          {hasError && (
            <AppAlertDialog title={'let op!'} open={hasError} onClose={handleOnClose}>
              <Box>
                <FormattedMessage
                  id={'default.error'}
                  defaultMessage={`Door een technische storing kunnen we nu helaas geen berekening uitvoeren. Probeer het
              opnieuw.`}
                />
              </Box>
            </AppAlertDialog>
          )}
          <div className={`col-span-12 md:col-span-5`}>
            {!result && <CalculatorsHomeValueCta></CalculatorsHomeValueCta>}
            {result && !isMobile && <CalculatorHomeValueCtaResult></CalculatorHomeValueCtaResult>}
          </div>
          <div
            className={`col-span-12 ${
              result ? 'md:col-start-7 md:col-span-6' : 'md:col-start-7 md:col-span-6'
            }`}>
            <div hidden={!!result}>
              <CalculatorHomeValueStepper></CalculatorHomeValueStepper>
            </div>
            {result && <CalculatorHomeValueResult></CalculatorHomeValueResult>}
          </div>
        </div>
      </HomeValueProvider>
    </IntlProvider>
  );
};
